import * as React from "react";

/**
 * Alarm-bell glyph for the overdue-to-dos nudge. Strokes use `currentColor` so the pill's
 * `IconWrap` accent colour (charts.primary) drives it, matching the recap pill's icon.
 */
export const OverdueBellIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="inherit"
    {...props}
  >
    <path
      d="M2.38278 7.25036C2.87976 5.50884 3.837 3.96141 5.11456 2.74803M18.8855 2.74803C20.163 3.96141 21.1202 5.50884 21.6172 7.25036M15.8978 18.749C15.1794 20.3808 13.7038 21.5 12 21.5C10.2962 21.5 8.82055 20.3808 8.10219 18.749M4.63278 18.5H19.3672C19.9687 18.5 20.4341 17.9728 20.3595 17.376L19.3062 8.94981C18.8456 5.26511 15.7134 2.5 12 2.5C8.28663 2.5 5.15436 5.26511 4.69377 8.94981L3.6405 17.376C3.5659 17.9728 4.03128 18.5 4.63278 18.5Z"
      stroke="currentColor"
      strokeWidth={1.33333}
      strokeLinecap="round"
    />
  </svg>
);
